import PropTypes from 'prop-types'
import { getFontSize } from '../../helpers/fontSize'
import { UseTypeFontSize } from '../hooks/useTypeFontSize'

export const Image = ({ src, alt, className, onClick, style, ...props }) => {
  const typeFontSize = UseTypeFontSize()

  return (
    <img
      src={src}
      alt={alt}
      className={['cursorPointer', className].join(' ')}
      onClick={onClick}
      style={{
        ...style,
        width: getFontSize(style.width, typeFontSize),
        height: getFontSize(style.height, typeFontSize),
      }}
      {...props}
    />
  )
}

Image.propTypes = {
  src: PropTypes.any.isRequired,
  alt: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func,
  style: PropTypes.object,
}

Image.defaultProps = {
  alt: '',
  className: '',
  onClick: () => {},
  style: {
    width: 28,
    height: 28,
    marginLeft: 2,
    marginRight: 2,
  },
}
